import { render, staticRenderFns } from "./show.support-tickets.page.vue?vue&type=template&id=231ebfbe&scoped=true&"
import script from "./show.support-tickets.page.vue?vue&type=script&lang=js&"
export * from "./show.support-tickets.page.vue?vue&type=script&lang=js&"
import style0 from "./show.support-tickets.page.vue?vue&type=style&index=0&id=231ebfbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231ebfbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VBtn,VResponsive})
